import React from 'react';
import Typography from "@material-ui/core/Typography";
import { Card, CardHeader, CardContent } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        height: "100%",
        background: "#354051",
    },
    heading: {
      color: "white",
      textAlign: "center",
      marginBottom: "1rem",
    },
    timeline: {
        position: "relative",
        left: "50%",
        transform: "translateX(-50%)",
        maxWidth: '800px',
        padding: "40px 20px 20px 20px",
    },
    timelineEntry: {
        marginTop: '10px',
        '&:lastOfType': {
            marginBottom: '0px',
        },
        display: 'block',
    },
    timelineEntryChip: {
        float: 'left',
        marginRight: '5px',
        marginBottom: '5px',
        display: 'inline-block',
    },
    timelineEntries: {
        display: 'inline-block',
        marginTop: '20px',
    },
}));


const Privacy = () => {

  const classes = useStyles();

  return (
    <div className={classes.root}>
            <div className={classes.timeline}>
                <div className={classes.timelineEntry}>
                    <Typography variant="h4" className={classes.heading}>
                      PRIVACY POLICY
                    </Typography>
                </div>
                <div className={classes.timeline}>
                    <Card>
                      <CardContent>
                        <p>This policy is effective as of 2022-03-29.</p>
                        <p>Goran Drakulić Portfolio site („we“, „our“ or „us“) is committed to protecting your privacy. This Privacy Policy explains how your personal information is collected, used, and disclosed by Goran Drakulić.</p>
                        <p>This Privacy Policy applies to our site named Goran Drakulić Portfolio, and its associated subdomains (collectively, our "Service"). By accessing or using our Service, you signify that you have read, understood, and agree to our collection, storage, use, and disclosure of your personal information as described in this Privacy Policy and our Terms of Service.</p>
                        <p>Goran Drakulić Portfolio site is an Ad Supported and Free site. Basic Service is provided at no cost and is intended for use as is</p>
                        <p>If you choose to use Service, then you agree to the collection and use of information in relation to this policy. Collected Personal Information is used for providing and improving the Service, and will not be used or shared with anyone except as described in this Privacy Policy</p>
                        <p>The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Goran Drakulić Portfolio site, unless otherwise defined in this Privacy Policy.</p>
                      </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Definitions and key terms"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                             For this Privacy Policy:
                            <ul>
                                <li><b>Cookie:</b> file with a small amount of data generated by a website and saved by your web browser, that is commonly used as anonymous unique identifier. It is sent to your browser from the websites that you visit and is stored on your device's internal memory. It is used to identify your browser, provide analytics, remember information about you such as your language preference or login information.</li>
                                <li><b>Company:</b> when this policy mentions “Company,” “we,” “us,” or “our,” it refers to Goran Drakulić Portfolio site that is responsible for your information under this Privacy Policy.</li>
                                <li><b>Country:</b> where Goran Drakulić Portfolio site or the owners/founders of Goran Drakulić Portfolio site are based, in this case is Serbia.</li>
                                <li><b>Customer:</b> refers to the company, organization or person that signs up to use the Goran Drakulić Portfolio Service to manage the relationships with your consumers or service users.</li>
                                <li><b>Device:</b> any internet connected device such as a phone, tablet, computer or any other device that can be used to visit Goran Drakulić Portfolio site and use the services.</li>
                                <li><b>IP address:</b> Every device connected to the Internet is assigned a number known as an Internet protocol (IP) address. These numbers are usually assigned in geographic blocks. An IP address can often be used to identify the location from which a device is connecting to the Internet.</li>
                                <li><b>Personnel:</b> refers to those individuals who are employed by Goran Drakulić Portfolio site or are under contract to perform a service on behalf of one of the parties.</li>
                                <li><b>Personal Data:</b> any information that directly, indirectly, or in connection with other information — including a personal identification number — allows for the identification or identifiability of a natural person.</li>
                                <li><b>Service:</b> refers to the service provided by Goran Drakulić Portfolio site as described in the relative terms (if available) and on this platform.</li>
                                <li><b>Third-party service:</b> refers to advertisers, contest sponsors, promotional and marketing partners, and others who provide our content or whose products or services we think may interest you.</li>
                                <li><b>Website:</b> Goran Drakulić Portfolio site, which can be accessed via this URL: https://sites.google.com/view/portfoliogd.</li>
                                <li><b>You:</b> a person or entity that is registered with Goran Drakulić Portfolio site to use the Services.</li>
                            </ul>
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Information automatically collected"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            There is some information like your Internet Protocol (IP) address and/or browser and device characteristics — is collected automatically when you visit our platform. This information may be used to connect your computer to the Internet. Other information collected automatically could be a login, e-mail address, password, computer and connection information such as browser plug-in types and versions and time zone setting, operating systems and platforms, purchase history, (we sometimes aggregate with similar information from other Users), the full Uniform Resource Locator (URL) clickstream to, through and from our Website that may include date and time; cookie number; parts of the site you viewed or searched for; and the phone number you used to call our Customer Services. We may also use browser data such as cookies, Flash cookies (also known as Flash Local Shared Objects) or similar data on certain parts of our Website for fraud prevention and other purposes. During your visits, we may use software tools such as JavaScript to measure and collect session information including page response times, download errors, length of visits to certain pages, page interaction information (such as scrolling, clicks, and mouse-overs), and methods used to browse away from the page. We may also collect technical information to help us identify your device for fraud prevention and diagnostic purposes.
                          </p>
                          <p>
                            We automatically collect certain information when you visit, use or navigate the platform. This information does not reveal your specific identity (like your name or contact information) but may include device and usage information, such as your IP address, browser and device characteristics, operating system, language preferences, referring URLs, device name, country, location, information about who and when you use our and other technical information. This information is primarily needed to maintain the security and operation of our , and for our internal analytics and reporting purposes.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Information collected"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            For a better experience, while using Service, it may be required that you provide certain personally identifiable information, including but not limited to users name and email. Requested information will be retained by Service and third party services, and will be used as described in this privacy policy or in privacy policies of third party services.
                          </p>
                          <p>
                            Service does use third party services that may collect information used to identify you.
                          </p>
                          <p>
                             Link to privacy policy of third party service providers used by the site:
                            <ul>
                                <li>
                                    <a href="https://policies.google.com/privacy">Google Play Services</a>
                                </li>
                                <li>
                                    <a href="https://support.google.com/admob/answer/6128543?hl=en">AdMob</a>
                                </li>
                                <li>
                                    <a href="https://firebase.google.com/policies/analytics">Google Analytics for Firebase</a>
                                </li>
                                <li>
                                    <a href="https://firebase.google.com/support/privacy/">Firebase Crashlytics</a>
                                </li>
                                <li>
                                    <a href="https://expo.dev/privacy/">Expo</a>
                                </li>
                            </ul>
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Log Data"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            In a case of an error, Service and third party services collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the site when utilizing Service, the time and date of your use of the Service, and other statistics.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="How Do We Use The Information We Collect?"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                             Any of the information we collect from you may be used in one of the following ways:
                            <ul>
                                <li>
                                    To personalize your experience (your information helps us to better respond to your individual needs),
                                </li>
                                <li>
                                    To improve our service (we continually strive to improve our service offerings based on the information and feedback we receive from you),
                                </li>
                                <li>
                                    To improve customer service (your information helps us to more effectively respond to your customer service requests and support needs),
                                </li>
                                <li>
                                    To process transactions,
                                </li>
                                <li>
                                    To administer a contest, promotion, survey or other site feature,
                                </li>
                                <li>
                                    To send periodic emails.
                                </li>
                            </ul>
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="When do we use customer information from third parties?"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We receive some information from the third parties when you contact us. For example, when you submit your email address to us to show interest in becoming our customer, we receive information from a third party that provides automated fraud detection services to us. We also occasionally collect information that is made publicly available on social media websites. You can control how much of your information social media websites make public by visiting these websites and changing your privacy settings.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Do we share the information we collect with third parties?"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We may share the information that we collect, both personal and non-personal, with third parties such as advertisers, contest sponsors, promotional and marketing partners, and others who provide our content or whose products or services we think may interest you. We may also share it with our current and future affiliated companies and business partners, and if we are involved in a merger, asset sale or other business reorganization, we may also share or transfer your personal and non-personal information to our successors-in-interest.
                          </p>
                          <p>
                            We may engage trusted third party service providers to perform functions and provide services to us, such as hosting and maintaining our servers and our service, database storage and management, e-mail management, storage marketing, credit card processing, customer service and fulfilling orders for products and services you may purchase through our platform. We will likely share your personal information, and possibly some non-personal information, with these third parties to enable them to perform these services for us and for you.
                          </p>
                          <p>
                            We may share portions of our log file data, including IP addresses, for analytics purposes with third parties such as web analytics partners, application developers, and ad networks. If your IP address is shared, it may be used to estimate general location and other technographic such as connection speed, whether you have visited the service in a shared location, and type of device used to visit the service. They may aggregate information about our advertising and what you see on the service and then provide auditing, research and reporting for us and our advertisers.
                          </p>
                          <p>
                            We may also disclose personal and non-personal information about you to government or law enforcement officials or private parties as we, in our sole discretion, believe necessary or appropriate in order to respond to claims, legal process (including subpoenas), to protect our rights and interests or those of a third party, the safety of the public or any person, to prevent or stop any illegal, unethical, or legally actionable activity, or to otherwise comply with applicable court orders, laws, rules and regulations.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Where and when is information collected from customers and end users?"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We will collect personal information that you submit to us. We may also receive personal information about you from third parties as described above.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Could my information be transferred to other countries?"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We are incorporated in Serbia. Information collected via our website, through direct interactions with you, or from use of our help services may be transferred from time to time to our offices or personnel, or to third parties, located throughout the world, and may be viewed and hosted anywhere in the world, including countries that may not have laws of general applicability regulating the use and transfer of such data. To the fullest extent allowed by applicable law, by using any of the above, you voluntarily consent to the trans- border transfer and hosting of such information.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Is the information collected through our service secure?"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We take precautions to protect the security of your information. We have physical, electronic, and managerial procedures to help safeguard, prevent unauthorized access, maintain data security, and correctly use your information. However, neither people nor security systems are foolproof, including encryption systems. In addition, people can commit intentional crimes, make mistakes or fail to follow policies. Therefore, while we use reasonable efforts to protect your personal information, we cannot guarantee its absolute security. If applicable law imposes any non-disclaimable duty to protect your personal information, you agree that intentional misconduct will be the standards used to measure our compliance with that duty.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Can I update or correct my information?"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            The rights you have to request updates or corrections to the information we collect depend on your relationship with us. Personnel may update or correct their information as detailed in our internal company employment policies. Customers have the right to request the restriction of certain uses and disclosures of personally identifiable information as follows. You can contact us in order to (1) update or correct your personally identifiable information, (2) change your preferences with respect to communications and other information you receive from us, or (3) delete the personally identifiable information maintained about you on our systems (subject to the following paragraph), by cancelling your account. Such updates, corrections, changes and deletions will have no effect on other information that we maintain, or information that we have provided to third parties in accordance with this Privacy Policy prior to such update, correction, change or deletion. To protect your privacy and security, we may take reasonable steps (such as requesting a unique password) to verify your identity before granting you profile access or making corrections. You are responsible for maintaining the secrecy of your unique password and account information at all times. You should be aware that it is not technologically possible to remove each and every record of the information you have provided to us from our system. The need to back up our systems to protect information from inadvertent loss means that a copy of your information may exist in a non-erasable form that will be difficult or impossible for us to locate. Promptly after receiving your request, all personal information stored in databases we actively use, and other readily searchable media will be updated, corrected, changed or deleted, as appropriate, as soon as and to the extent reasonably and technically practicable. If you are an end user and wish to update, delete, or receive any information we have about you, you may do so by contacting the organization of which you are a customer.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Sale of Business"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We reserve the right to transfer information to a third party in the event of a sale, merger or other transfer of all or substantially all of the assets of us or any of its Corporate Affiliates (as defined herein), or that portion of us or any of its Corporate Affiliates to which the Service relates, or in the event that we discontinue our business or file a petition or have filed against us a petition in bankruptcy, reorganization or similar proceeding, provided that the third party agrees to adhere to the terms of this Privacy Policy
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Affiliates"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We may disclose information (including personal information) about you to our Corporate Affiliates. For purposes of this Privacy Policy, "Corporate Affiliate" means any person or entity which directly or indirectly controls, is controlled by or is under common control with us, whether by ownership or otherwise. Any information relating to you that we provide to our Corporate Affiliates will be treated by those Corporate Affiliates in accordance with the terms of this Privacy Policy.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="How Long Do We Keep Your Information?"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We keep your information only so long as we need it to provide service to you and fulfill the purposes described in this policy. This is also the case for anyone that we share your information with and who carries out services on our behalf. When we no longer need to use your information and there is no need for us to keep it to comply with our legal or regulatory obligations, we'll either remove it from our systems or depersonalize it so that we can't identify you.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="How Do We Protect Your Information?"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We implement a variety of security measures to maintain the safety of your personal information when you place an order or enter, submit, or access your personal information. We offer the use of a secure server. All supplied sensitive/credit information is transmitted via Secure Socket Layer (SSL) technology and then encrypted into our Payment gateway providers database only to be accessible by those authorized with special access rights to such systems, and are required to keep the information confidential. After a transaction, your private information (credit cards, social security numbers, financials, etc.) is never kept on file. We cannot, however, ensure or warrant the absolute security of any information you transmit to us or guarantee that your information on the Service may not be accessed, disclosed, altered, or destroyed by a breach of any of our physical, technical, or managerial safeguards.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Governing Law"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            The laws of Serbia, excluding its conflicts of law rules, shall govern this Agreement and your use of our service. Your use of our service may also be subject to other local, state, national, or international laws.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Your Consent"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            By using our service, registering an account, or making a purchase, you consent to this Privacy Policy.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Links to Other Websites"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            This Privacy Policy applies only to the Services. The Services may contain links to other websites not operated or controlled by Goran Drakulić Portfolio site. We are not responsible for the content, accuracy or opinions expressed in such websites, and such websites are not investigated, monitored or checked for accuracy or completeness by us. Please remember that when you use a link to go from the Services to another website, our Privacy Policy is no longer in effect. Your browsing and interaction on any other website, including those that have a link on our platform, is subject to that website’s own rules and policies. Such third parties may use their own cookies or other methods to collect information about you. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over those websites and we assume no responsibility for the content, privacy policies or practices of any third-party sites or services.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Cookies"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We use "Cookies" to identify the areas of our website that you have visited, to collect information and to improve site. A Cookie is a small piece of data stored on your computer or mobile device by your web browser. We use Cookies to personalize the Content that you see on our website. Most web browsers can be set to disable the use of Cookies. However, if you disable Cookies, you may not be able to access functionality on our website correctly or at all. We never place Personally Identifiable Information in Cookies.
                          </p>
                          <p>
                            Also, the Service may use third party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Service Providers"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                             We may use third-party companies and individuals due to the following reasons:
                            <ul>
                                <li>
                                    To facilitate our Service;
                                </li>
                                <li>
                                    To provide the Service on our behalf;
                                </li>
                                <li>
                                    To perform Service-related services; or
                                </li>
                                <li>
                                    To assist us in analyzing how our Service is used.
                                </li>
                            </ul>
                          </p>
                          <p>
                            We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Security"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Advertising"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            Advertising keeps us and many of the websites and services you use free of charge. We work hard to make sure that ads are safe, unobtrusive, and as relevant as possible.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Cookies for Advertising"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            Cookies help to make advertising more effective. Without cookies, it's really hard for an advertiser to reach its audience, or to know how many ads were shown and how many clicks they received.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Remarketing Services"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We use remarketing services. What Is Remarketing? In digital marketing, remarketing (or retargeting) is the practice of serving ads across the internet to people who have already visited your website. It allows your company to seem like they're “following” people around the internet by serving ads on the websites and platforms they use most.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Payment Details"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            In respect to any credit card or other payment processing details you have provided us, we commit that this confidential information will be stored in the most secure manner possible.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Kids' Privacy"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from our servers.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Changes To Our Privacy Policy"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. If we decide to change our privacy policy, we will post those changes on this page, and/or update the Privacy Policy date. These changes are effective immediately, after they are posted on this page.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Third-Party Services"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We may display, include or make available third-party content (including data, information, applications and other products services) or provide links to third-party websites or services ("Third- Party Services"). You acknowledge and agree that we shall not be responsible for any Third-Party Services, including their accuracy, completeness, timeliness, validity, copyright compliance, legality, decency, quality or any other aspect thereof. We do not assume and shall not have any liability or responsibility to you or any other person or entity for any Third-Party Services. Third-Party Services and links thereto are provided solely as a convenience to you and you access and use them entirely at your own risk and subject to such third parties' terms and conditions.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Facebook Pixel"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            Facebook pixel is an analytics tool that allows you to measure the effectiveness of your advertising by understanding the actions people take on your website. You can use the pixel to: Make sure your ads are shown to the right people. Facebook pixel may collect information from your device when you use the service. Facebook pixel collects information that is held in accordance with its Privacy Policy.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Information about General Data Protection Regulation (GDPR)"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We may be collecting and using information from you if you are from the European Economic Area (EEA), and in this section of our Privacy Policy we are going to explain exactly how and why is this data collected, and how we maintain this data under protection from being replicated or used in the wrong way.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="What is GDPR?"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            GDPR is an EU-wide privacy and data protection law that regulates how EU residents' data is protected by companies and enhances the control the EU residents have, over their personal data.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="What is personal data?"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            Any data that relates to an identifiable or identified individual. GDPR covers a broad spectrum of information that could be used on its own, or in combination with other pieces of information, to identify a person. Personal data extends beyond a person’s name or email address. Some examples include financial information, political opinions, genetic data, biometric data, IP addresses, physical address, sexual orientation, and ethnicity. The Data Protection Principles include requirements such as:
                            <ul>
                                <li>
                                    Personal data collected must be processed in a fair, legal, and transparent way and should only be used in a way that a person would reasonably expect.
                                </li>
                                <li>
                                    Personal data should only be collected to fulfil a specific purpose and it should only be used for that purpose. Organizations must specify why they need the personal data when they collect it.
                                </li>
                                <li>
                                    Personal data should be held no longer than necessary to fulfil its purpose.
                                </li>
                                <li>
                                    People covered by the GDPR have the right to access their own personal data. They can also request a copy of their data, and that their data be updated, deleted, restricted, or moved to another organization.
                                </li>
                            </ul>
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Why is GDPR important?"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            GDPR adds some new requirements regarding how companies should protect individuals' personal data that they collect and process. It also raises the stakes for compliance by increasing enforcement and imposing greater fines for breach. Beyond these facts it's simply the right thing to do. At Help Scout we strongly believe that your data privacy is very important and we already have solid security and privacy practices in place that go beyond the requirements of this new regulation.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Individual Data Subject's Rights - Data Access, Portability and Deletion"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            We are committed to helping our customers meet the data subject rights requirements of GDPR. We process or store all personal data in fully vetted, DPA compliant vendors. We do store all conversation and personal data for up to 6 years unless your account is deleted. In which case, we dispose of all data in accordance with our Terms of Service and Privacy Policy, but we will not hold it longer than 60 days.
                          </p>
                          <p>
                            We are aware that if you are working with EU customers, you need to be able to provide them with the ability to access, update, retrieve and remove personal data. We got you! We've been set up as self service from the start and have always given you access to your data and your customers data. Our customer support team is here for you to answer any questions you might have about working with the API.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="California Residents"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            The California Consumer Privacy Act (CCPA) requires us to disclose categories of Personal Information we collect and how we use it, the categories of sources from whom we collect Personal Information, and the third parties with whom we share it, which we have explained above. We are also required to communicate information about rights California residents have under California law. You may exercise the following rights:
                            <ul>
                                <li>
                                    Right to Know and Access. You may submit a verifiable request for information regarding the: (1) categories of Personal Information we collect, use, or share; (2) purposes for which categories of Personal Information are collected or used by us; (3) categories of sources from which we collect Personal Information; and (4) specific pieces of Personal Information we have collected about you.
                                </li>
                                <li>
                                    Right to Equal Service. We will not discriminate against you if you exercise your privacy rights.
                                </li>
                                <li>
                                    Right to Delete. You may submit a verifiable request to close your account and we will delete Personal Information about you that we have collected.
                                </li>
                                <li>
                                    Request that a business that sells a consumer's personal data, not sell the consumer's personal data.
                                </li>
                            </ul>
                          </p>
                          <p>
                            If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.
                          </p>
                          <p>
                            We do not sell the Personal Information of our users.
                          </p>
                          <p>
                            For more information about these rights, please contact us.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="California Online Privacy Protection Act (CalOPPA)"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            CalOPPA requires us to disclose categories of Personal Information we collect and how we use it, the categories of sources from whom we collect Personal Information, and the third parties with whom we share it, which we have explained above.
                          </p>
                          <p>
                            CalOPPA users have the following rights:
                            <ul>
                                <li>
                                    Right to Know and Access. You may submit a verifiable request for information regarding the: (1) categories of Personal Information we collect, use, or share; (2) purposes for which categories of Personal Information are collected or used by us; (3) categories of sources from which we collect Personal Information; and (4) specific pieces of Personal Information we have collected about you.
                                </li>
                                <li>
                                    Right to Equal Service. We will not discriminate against you if you exercise your privacy rights.
                                </li>
                                <li>
                                    Right to Delete. You may submit a verifiable request to close your account and we will delete Personal Information about you that we have collected.
                                </li>
                                <li>
                                    Right to request that a business that sells a consumer's personal data, not sell the consumer's personal data.
                                </li>
                            </ul>
                          </p>
                          <p>
                            If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.
                          </p>
                          <p>
                            We do not sell the Personal Information of our users.
                          </p>
                          <p>
                            For more information about these rights, please contact us.
                          </p>
                        </CardContent>
                    </Card>
                </div>
                <div className={classes.timeline}>
                    <Card>
                        <CardHeader
                            title="Contact Us"
                            titleTypographyProps={{ variant: 'h6' }}
                        />
                        <CardContent>
                          <p>
                            Don't hesitate to contact us if you have any questions or suggestions.
                            <ul>
                                <li>
                                    Via Email: drakulic@hotmail.com
                                </li>
                            </ul>
                          </p>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </div>
  );
}

export default Privacy;
